import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, RefreshCw } from 'lucide-react';
import api from '../../../../utils/api';
import PendingMessageCard from '../../../../components/automation/PendingMessageCard';
import MainLayout from '../../../../components/layout/MainLayout';

const PendingQueue = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchJobs = async () => {
    try {
      const res = await api('/automation/pending-jobs');
      if (!res.ok) throw new Error('Failed to fetch jobs');
      const data = await res.json();
      setJobs(data.jobs || data || []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching jobs:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
    const interval = setInterval(fetchJobs, 30000); // Auto-refresh every 30s
    return () => clearInterval(interval);
  }, []);

  const handleCancel = async (id) => {
    if (!window.confirm('Are you sure you want to cancel this scheduled message?')) return;
    try {
      const res = await api(`/automation/jobs/${id}/cancel`, { method: 'PATCH' });
      if (!res.ok) throw new Error('Failed to cancel');
      fetchJobs();
    } catch (error) {
      console.error('Error cancelling job:', error);
      alert('Failed to cancel job');
    }
  };

  return (
    <MainLayout>
      <div style={{ padding: '24px', maxWidth: '1000px', margin: '0 auto' }}>
        <button 
          onClick={() => navigate('/automation/whatsapp-api/bulk')}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px', 
            background: 'none', 
            border: 'none', 
            color: 'var(--color-text-secondary)',
            cursor: 'pointer',
            marginBottom: '24px',
            padding: 0,
            fontSize: '14px'
          }}
        >
          <ArrowLeft size={16} /> Back to Bulk Messaging
        </button>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <div>
            <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '4px' }}>Pending Messages</h1>
            <p style={{ color: 'var(--color-text-tertiary)', fontSize: '14px' }}>View and manage your scheduled broadcast messages.</p>
          </div>
          <button 
            onClick={fetchJobs}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px',
              padding: '8px 16px',
              background: 'white',
              border: '1px solid var(--color-border-primary)',
              borderRadius: '6px',
              cursor: 'pointer',
              color: 'var(--color-text-secondary)'
            }}
          >
            <RefreshCw size={14} /> Refresh
          </button>
        </div>

        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center', color: 'var(--color-text-tertiary)' }}>Loading queue...</div>
        ) : jobs.length === 0 ? (
          <div style={{ 
            background: 'var(--color-background-primary)', 
            border: '1px dashed var(--color-border-primary)', 
            borderRadius: '12px', 
            padding: '48px', 
            textAlign: 'center',
            color: 'var(--color-text-tertiary)'
          }}>
            No pending or scheduled messages found.
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '24px' }}>
            {jobs.map(job => (
              <PendingMessageCard key={job._id} job={job} onCancel={handleCancel} />
            ))}
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default PendingQueue;
